var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3451 11.6771C11.1011 11.4619 10.984 11.2018 10.9938 10.8969C11.0035 10.5919 11.1308 10.3318 11.3756 10.1166L14.8218 7.07623H1.21991C0.874267 7.07623 0.584338 6.97291 0.350116 6.76628C0.115895 6.55964 -0.000809047 6.30421 4.22111e-06 6C4.22111e-06 5.69507 0.117115 5.43928 0.351336 5.23265C0.585557 5.02601 0.875081 4.92305 1.21991 4.92377H14.8218L11.3451 1.8565C11.1011 1.64125 10.9791 1.38547 10.9791 1.08915C10.9791 0.792825 11.1011 0.537399 11.3451 0.32287C11.5891 0.107623 11.879 0 12.2149 0C12.5508 0 12.8403 0.107623 13.0835 0.32287L18.6645 5.24664C18.7865 5.35426 18.8731 5.47085 18.9243 5.59641C18.9756 5.72197 19.0008 5.8565 19 6C19 6.1435 18.9744 6.27803 18.9231 6.40359C18.8719 6.52915 18.7857 6.64574 18.6645 6.75336L13.053 11.704C12.8293 11.9013 12.55 12 12.2149 12C11.8798 12 11.5899 11.8924 11.3451 11.6771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.63c94599.svg";
export { ForwardRef as ReactComponent };